export default __webpack_public_path__ + "static/photo-2fb341658588738fcd414b031c4f6a80.jpeg";